import { supabase } from '@/config/supabase'

/**
 * Autenticazione dell'area riservata.
 *
 * Prima le credenziali stavano in una costante del modulo e il confronto
 * avveniva nel browser: Vite le sostituisce col valore letterale in fase di
 * build, quindi erano leggibili nel JavaScript pubblico da chiunque aprisse il
 * sito. E `isAuthenticated()` si accontentava di trovare una qualsiasi chiave
 * in localStorage, quindi si entrava anche senza saperle.
 *
 * Ora la password la verifica Supabase e il pannello lavora con un token
 * firmato, che e' anche cio' che le policy RLS usano per decidere chi vede
 * quali dati. Per il cliente non cambia niente: continua a digitare lo stesso
 * nome utente e la stessa password di prima. L'email qui sotto e' solo il modo
 * in cui Supabase identifica gli account — quel dominio non riceve posta.
 */
const DOMINIO = 'cagliari.valutatori.local'

function emailDaUtente(username: string): string {
  return `${username.trim().toLowerCase()}@${DOMINIO}`
}

export async function login(username: string, password: string): Promise<boolean> {
  const { error } = await supabase.auth.signInWithPassword({
    email: emailDaUtente(username),
    password,
  })
  if (error) {
    console.warn('Accesso non riuscito:', error.message)
    return false
  }
  return true
}

export async function isAuthenticated(): Promise<boolean> {
  const { data } = await supabase.auth.getSession()
  return Boolean(data.session)
}

export async function logout(): Promise<void> {
  await supabase.auth.signOut()
}
